import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { AllIncompleteCustomerOrderSalesConditionsPage } from "src/components/views/erp/sales/customerOrder/CustomerOrdersSalesConditionManagementPage.tsx";

export const Route = createFileRoute("/_authenticated/_shell/sales/customerOrderSalesConditions")({
	staticData: {
		title: i18n.t("customer_orders_sales_conditions"),
		legacyViewKey: "allIncompleteCustomerOrderSalesConditionsPage",
	},
	component: RouteComponent,
});

function RouteComponent() {
	return <AllIncompleteCustomerOrderSalesConditionsPage />;
}
